import React from "react";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import Header from './Header';
import Footer from './Footer';
import RecentPost from './RecentPost';

const SSLSetupBlog = () => {
  return (
    <>
    <Header />
    <div className="full-div" id="blog">
      <Container fluid className="main-sec">
        <Row>
          <Col sm={2}></Col>
          <Col sm={7} className="bg-white p-4 div-shadow mb-3">
            <h1 className="head-color">
              How to Set Up SSL Certificates in cPanel for Enhanced Security
            </h1>
            <span className="small ms-2">
              <b>Publish By:-</b> CodeInputs
            </span>

            <Row className="mt-3 text-center">
              <Col md={12}>
                <Image src="/graphics/images/secure_web.webp" width="100%" alt="backup" fluid />
              </Col>
            </Row>

            <p className="mt-4 blacktext">
              This guide walks you through the process of setting up SSL certificates in cPanel, ensuring your website is secure and trustworthy. Learn the importance of SSL for online security and follow easy steps to activate SSL on your cPanel server, boosting both user confidence and SEO.
            </p>

            <h4>What is SSL?</h4>
            <p className="mt-4 blacktext">
              A secure technique known as SSL, or Secure Sockets Layer, creates an encrypted connection between a user's browser and a web server. Any data sent between the browser and the server is protected and kept private thanks to this encryption. SSL is necessary to prevent hackers from intercepting private data, including credit card numbers, login credentials, and personal information.
            </p>

            <p className="mt-4 blacktext">When a website has an SSL certificate, its URL starts with https:// instead of http:// and a padlock icon appears in the browser's address bar. Because search engines like Google give priority to safe websites in their rankings, SSL not only increases website security but also helps SEO.</p>

            <Row className="mt-3">
              <Col md={12}>
                <Image src="/graphics/images/ssl.webp" width="100%" alt="ssl" fluid />
              </Col>
            </Row><br/>

            <p className="mt-4 blacktext">SSL has been largely replaced by TLS (Transport Layer Security), which is an updated and more secure version, but the term "SSL" is still commonly used to refer to both technologies.</p>

            <h4>Steps to activate SSL in cPanel</h4>
            <p className="mt-4 orgspan fw-bold">Step-1 Login to cPanel</p>
            <ul>
                  <li className="blacktext fw-normal mb-3">Access your cPanel dashboard by logging in with your credentials. The URL is usually something like yourdomain.com/cpanel.</li>
            </ul>

            <p className="mt-4 orgspan fw-bold">Step-2 Navigate to the SSL/TLS Section</p>
           <ul>
                  <li className="blacktext fw-normal mb-3">Scroll down to find the <b>"Security"</b> section and click on <b>"SSL/TLS"</b>. This is where you’ll manage SSL certificates.</li>
           </ul>


            <Row className="mt-3">
              <Col md={12}>
                <Image src="/graphics/images/ssltls.webp" width="100%" alt="ssl/tls" fluid />
              </Col>
            </Row>

            <h4>Step-3 Generate a Certificate Signing Request (CSR)</h4>
            <ul>
                  <li className="blacktext fw-normal mb-3">If you're purchasing a new SSL certificate, you’ll first need a <b>CSR</b>.</li>

                  <div className="row mt-3">
                  <div className="col-md-12">
                      <img className="img-responsive" src="/images/csr.webp" width="100%" alt="backup"/>
                    </div>
                </div>

                  <li className="blacktext fw-normal mb-3">In the SSL/TLS section, click "<b>Generate, view, or delete SSL certificate signing requests</b>".</li>

                  <div className="row mt-3">
                  <div className="col-md-12">
                      <img className="img-responsive" src="/images/generate.webp" width="100%" alt="backup"/>
                    </div>
                </div>

                  <li className="blacktext fw-normal mb-3">Enter your domain, organization details, and other required information, then generate the CSR.</li>

                  <div className="row mt-3">
                  <div className="col-md-12">
                      <img className="img-responsive" src="/images/add_generate.webp" width="100%" alt="backup"/>
                    </div>
                </div>

                  <li className="blacktext fw-normal mb-3">Copy the CSR code to provide to your SSL certificate provider when purchasing the certificate.</li>
                </ul><br/>

            <h4>Step-4 Install the SSL Certificate</h4>
            <ul>
                  <li className="blacktext fw-normal mb-3">Once you receive the SSL certificate files from your provider, go back to the <b>SSL/TLS</b> section in cPanel.</li>

                  <li className="blacktext fw-normal mb-3">Click "<b>Manage SSL Sites</b>" under "<b>Install and Manage SSL for your site (HTTPS)</b>".</li>

                  <div className="row mt-3">
                  <div className="col-md-12">
                      <img className="img-responsive" src="images/manage_ssl.webp" width="100%" alt="backup"/>
                    </div>
                </div>

                  <li className="blacktext fw-normal mb-3">In the "Domain" dropdown, select the domain where you want to install the SSL certificate.</li>

                  <div className="row mt-3">
                  <div className="col-md-12">
                      <img className="img-responsive" src="images/select_domain.webp" width="100%" alt="backup"/>
                    </div>
                </div>

                  <li className="blacktext fw-normal mb-3">Paste the certificate details (Certificate, Private Key, and CA Bundle) provided by your SSL issuer into the appropriate fields.</li>
                </ul>

            <h4>Step-5 Activate AutoSSL (If Available)</h4>
            <ul>
                  <li className="blacktext fw-normal mb-3">Many cPanel setups offer a free SSL option via <b>AutoSSL.</b></li>

                  <li className="blacktext fw-normal mb-3">If AutoSSL is available, go to <b>SSL/TLS</b> Status or the <b>AutoSSL</b> section.</li>

                  <div className="row mt-3">
                  <div className="col-md-12">
                      <img className="img-responsive" src="/images/tls_status.webp" width="100%" alt="backup"/>
                    </div>
                </div>

                  <li className="blacktext fw-normal mb-3">Click <b>"Run AutoSSL"</b> to automatically generate and install an SSL certificate for your domain.</li>
                </ul>

            <h4>Step-6 Verify SSL Installation</h4>
            <ul>
                  <li className="blacktext fw-normal mb-3">Visit your website with <b>https://</b> in the URL. If the SSL was successfully installed, a padlock icon should appear in the browser address bar.</li>

                  <div className="row mt-3">
                  <div className="col-md-12">
                      <img className="img-responsive" src="/images/ssl_lock.webp" width="100%" alt="backup"/>
                    </div>
                </div>

                  <li className="blacktext fw-normal mb-3">You can also use online tools like SSL Checker to confirm the SSL certificate's validity.</li>
                </ul>

            <p className="text-dark">With these steps, your SSL certificate should be active, securing your website and enabling HTTPS for your domain.</p>

            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/NL-FuD9NF0c?si=z-01oK2vsHnzR3hz"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </Col>
          <Col sm={3} className="recent-post">
            <Card className="bg-white p-4 mb-3 div-shadow">
              <h4 className="head-color">Recent Post</h4>
              <RecentPost />
            </Card>
            <Card className="bg-white p-4 div-shadow">
              <h4 className="mt-4 head-color">Recent Comment</h4>
              <p style={{ color: "#85929e" }}>No Comments to Show</p>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
    <Footer />
    </>
  );
};

export default SSLSetupBlog;